import { ClipboardDocumentIcon } from '@heroicons/react/24/outline';
import { Tooltip } from '@odo/shared-ui';
import { useToast } from '../../../../providers/ToastProvider';
import { copyToClipboard } from '../../../../utils/clipboard';

interface ReferenceInlineProps {
    referenceNo: string;
}

// Compact table-row treatment - bare mono text, copy icon on row hover
// (parent `<tr>` carries `group`).
export function ReferenceInline({ referenceNo }: ReferenceInlineProps) {
    const { showToast } = useToast();

    const handleCopy = async (e: React.MouseEvent) => {
        e.stopPropagation();
        const copied = await copyToClipboard(referenceNo);
        showToast(
            copied ? 'Reference copied' : 'Could not copy reference',
            copied ? 'success' : 'error'
        );
    };

    // ONE tooltip carrying both the action and the full value - the truncated
    // reference stays readable and the copy affordance stays discoverable
    // without stacking two reveals on the same button.
    return (
        <Tooltip content={`Copy reference number: ${referenceNo}`}>
            <button
                type="button"
                onClick={handleCopy}
                className="flex w-full min-w-0 items-center gap-1.5 text-[12px] font-mono tabular-nums text-gray-700 hover:text-gray-900 transition-colors"
            >
                <span className="truncate">{referenceNo}</span>
                <ClipboardDocumentIcon className="h-3 w-3 text-gray-400 opacity-0 group-hover:opacity-100 transition-opacity shrink-0" />
            </button>
        </Tooltip>
    );
}
